import { Alert, Box } from '@cloudscape-design/components';

/**
 * SharedModeBanner Component
 *
 * Displays an informational banner when viewing shared filters
 * Automatically handles conditional rendering and spacing
 */
export interface SharedModeBannerProps {
  'isSharedMode': boolean;
  'isBUMismatch': boolean;
  'data-testid'?: string;
}

export function SharedModeBanner({
  isSharedMode,
  isBUMismatch,
  'data-testid': dataTestId,
}: SharedModeBannerProps) {
  // Don't render if not in shared mode or if there's a BU mismatch
  if (!isSharedMode || isBUMismatch) {
    return null;
  }

  return (
    <Box margin={{ bottom: 's' }} data-testid={dataTestId}>
      <Alert type="info">
        Viewing shared filters. Any filter changes will reset when you leave this page.
      </Alert>
    </Box>
  );
}
